//@flo
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/pt-br';
import * as React from 'react';
import Draggable from 'react-draggable'; // The default
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ButtonAutorized from '../../components/buttons/ButtonAutorized';
import FolhaCard from '../../components/FolhaCard/FolhaCard';
import VideoConference from '../../components/Jitsi/VideoConference';
import { ModalGerarDocumentos } from '../../components/Modal/ModalGerarDocumentos';
import { ModalConsultarProntuario } from '../../components/Modal/ModalConsultarProntuario';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import IconChamarPaciente from '../../images/icon-chamar-paciente.svg';
import IconIniciarAtendimento from '../../images/icon-iniciar-atendimento.svg';
import iconeReceituario from '../../images/icon-receituario.svg';
import IconSend from '../../images/icon-send-link.svg';
import iconePaciente from '../../images/icones/clipboard.svg';
import { objectsConstants } from '../../_constants/objects.constants';
import { ConfirmAcationService } from '../../_services/ConfirmAcationService';
import { marcacaoService } from '../../_services/marcacao.service';
import AnamneseDadosForm from './AnamneseDadosForm';
import AnamneseReceiruarioForm from './AnamneseReceiruarioForm';
import { prontuarioService } from '../../_services/prontuario.service';
import FolhaCardPanel from '../../components/FolhaCard/FolhaCardPanel';

type Props = {
  entity: any,
  data: date,
  showAvatar: boolean,
};

let callFrame;
let iframe;

class Anamnese extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showReceituario: false,
      openModalGerarDocumentos: false,
      openModalConsultarProntuario: false,
      documentosGerados: [],
    };
  }

  componentDidMount() {
    const { atendimentoEmAtendimento, entity } = this.props;
    if (atendimentoEmAtendimento && atendimentoEmAtendimento.telemedicina) {
      this.abreSalaTeleAtendimento(atendimentoEmAtendimento);
    }

    this.findMarcacao(
      atendimentoEmAtendimento
        ? _.get(atendimentoEmAtendimento, 'idMarcacao')
        : _.get(entity, 'marcacao.id')
    );
  }

  // componentWillUnmount() {
  //   if (callFrame) {
  //     this.fechaSataTeleatendimento();
  //   }
  // }

  abreSalaTeleAtendimento(atendimento) {
    this.setState({ showMeetConfrence: true });
  }

  fechaSataTeleatendimento = () => {
    callFrame.destroy();
    this.setState({ showMeetConfrence: false });
  };

  listaParticipante = () => {
    let participantes = callFrame.participants();
  };

  enviaMensagem = (msg) => {
    callFrame.sendAppMessage({ message: msg }, '*');
  };

  getIdade = (dataNascimento) => {
    if (dataNascimento) {
      let arrIdade = dataNascimento.split('-');
      var d = new Date(),
        ano_atual = d.getFullYear(),
        mes_atual = d.getMonth() + 1,
        dia_atual = d.getDate(),
        ano_nasc = +arrIdade[0],
        mes_nasc = +arrIdade[1],
        dia_nasc = +arrIdade[2],
        idade = ano_atual - ano_nasc;
      if (
        mes_atual < mes_nasc ||
        (mes_atual == mes_nasc && dia_atual < dia_nasc)
      ) {
        idade--;
      }
      if (idade < 1) {
        return ' meses';
      }
      if (idade === 1) {
        return idade + ' ano';
      }
      if (idade > 1) {
        return idade + ' anos';
      }
    }
  };

  getNomeConvenio = () => {
    const { atendimentoEmAtendimento } = this.props;
    const { marcacao } = this.state;
    let objAtual = marcacao ? marcacao : atendimentoEmAtendimento;

    if (
      _.get(objAtual, 'tipoAtendimento') ===
      objectsConstants.TIPO_ATENDIMENTO_CONVENIO
    ) {
      if (_.get(objAtual, 'planoConvenio')) {
        let nomePlano = _.get(_.get(objAtual, 'planoConvenio'), 'nome');
        return (
          ' (' +
          _.get(objAtual, 'convenio.nome', 'Convênio') +
          ' - ' +
          nomePlano +
          ')'
        );
      } else {
        let idConvenio = _.get(objAtual, 'convenio.id');
        if (idConvenio) {
          let listaConveniosPaciente = _.get(
            objAtual,
            'paciente.pacienteConvenios'
          );
          let plano = _.find(listaConveniosPaciente, function (conv) {
            return _.get(conv.convenio, 'id') === idConvenio;
          });
          let nomePlano = _.get(plano, 'planoConvenio.nome');
          return (
            ' (' +
            _.get(objAtual, 'convenio.nome', 'Convênio') +
            ' - ' +
            nomePlano +
            ')'
          );
        } else {
          return ' ';
        }
      }
    } else if (
      _.get(objAtual, 'tipoAtendimento') ===
      objectsConstants.TIPO_ATENDIMENTO_PARTICULAR
    ) {
      return ' (Particular)';
    } else if (
      _.get(objAtual, 'tipoAtendimento') ===
      objectsConstants.TIPO_ATENDIMENTO_CORTESIA
    ) {
      return ' (Cortesia)';
    }
  };

  copiaLink(value) {
    var textArea = document.createElement('textarea');
    textArea.value = value;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('Copy');
    textArea.remove();
    this.props.success({
      message: `URL copiada com sucesso`,
    });
  }

  canEditAnamnese = (prontuario) => {
    const { user } = this.props;
    let isCurrenteuser = user.id === _.get(prontuario.medico, 'id');
    let canEdit = false;
    if (
      (isCurrenteuser && !prontuario.id) ||
      (isCurrenteuser && moment(prontuario.dataHora).isSame(moment(), 'day'))
    ) {
      canEdit = true;
    }
    return canEdit;
  };

  toggleReceituario = () => {
    this.setState({ showReceituario: !this.state.showReceituario });
  };
  exibeBotaoReceituario = (prontuario) => {
    const { user } = this.props;
    let isCurrenteuser = user.id === _.get(prontuario.medico, 'id');
    let exibeBotao = false;
    if (isCurrenteuser && moment(prontuario.dataHora).isSame(moment(), 'day')) {
      exibeBotao = true;
    }
    if (prontuario.receituario && prontuario.receituario.id) {
      exibeBotao = false;
    }
    return exibeBotao;
  };

  sendEmail = (atendimentoMarcado) => {
    this.props.loading(true);
    marcacaoService.sendEmailAgendamento(atendimentoMarcado.idMarcacao).then(
      (result) => {
        this.props.loading(false);
        this.props.success({
          message: `E-mail reenviado com sucesso`,
        });
      },
      () => {
        this.props.loading(false);
      }
    );
  };

  userIsConected = (participantes, user) => {
    for (let i = 0; i < participantes.length; i++) {
      if (participantes[i].displayName === user.nome) {
        return true;
      }
    }
    return false;
  };

  participantLeft = (participantes) => {
    let medico = this.props.user;
    const { setTelemedicina } = this.props;
    if (this.userIsConected(participantes, medico)) {
      ConfirmAcationService.confirmMsg(
        () => {
          setTelemedicina({ nomeSala: null, showTelemedicina: false });
        },
        'Finalizar teleconsulta',
        <span>Deseja finalizar video chamada?</span>,
        <span className="text-danger">Chamada finalizada</span>,
        'Não',
        'Sim',
        objectsConstants.TYPE_WARNING
      );
    } else {
      setTelemedicina({ nomeSala: null, showTelemedicina: false });
    }
  };

  toggleModalGerarDocumentos = () => {
    this.setState(({ openModalGerarDocumentos }) => ({
      openModalGerarDocumentos: !openModalGerarDocumentos,
    }));
  };
  toggleModalConsultarProntuario = () => {
    this.setState(({ openModalConsultarProntuario }) => ({
      openModalConsultarProntuario: !openModalConsultarProntuario,
    }));
  };

  loadVideoConferencia = () => {
    const { user, showTelemedicina, nomeSala } = this.props;
    if (showTelemedicina && !this.props.viewMode) {
      return (
        <Draggable handle=".videocall">
          <div className={'card videocall d-flex flex-column'}>
            {' '}
            <VideoConference
              subject={'Tele Consulta'}
              participantLeft={this.participantLeft}
              roomName={nomeSala}
              userName={user.nome}
              userEmail={user.email}
            />{' '}
          </div>
        </Draggable>
      );
    }
    return null;
  };

  findMarcacao = (idMarcacao) => {
    marcacaoService.doGet(idMarcacao).then(
      (response) => {
        this.setState({
          marcacao: response.data.data,
        });
      },
      () => {
        console.log('Não foi possivel buscar marcação');
      }
    );
  };

  render() {
    const {
      entity,
      data,
      atendimentoParaChamar,
      atendimentoEmChamada,
      atendimentoEmAtendimento,
      atendimentoMarcado,
      user,
      ...otherProps
    } = this.props;
    let initValues = _.cloneDeep(entity);
    console.log(initValues);
    if (
      this.state.documentosGerados &&
      this.state.documentosGerados.length > 0
    ) {
      if (initValues.listAnexos) {
        initValues.listAnexos.push(this.state.documentosGerados);
      } else {
        initValues.listAnexos = this.state.documentosGerados;
      }
    }
    if (!initValues.anamnese) {
      initValues.anamnese = '';
    }

    let prontuarioImportado = false;
    let estabelecimento;
    if (
      (this.state.marcacao && this.state.marcacao.estabelecimento) ||
      (this.props.atendimentoEmAtendimento &&
        this.props.atendimentoEmAtendimento.estabelecimento)
    ) {
      prontuarioImportado = this.state.marcacao
        ? this.state.marcacao.estabelecimento.prontuarioImportado
        : this.props.atendimentoEmAtendimento.estabelecimento
            .prontuarioImportado;

      estabelecimento = this.state.marcacao
        ? this.state.marcacao.estabelecimento
        : this.props.atendimentoEmAtendimento.estabelecimento;
    }
    const { showReceituario, showMeetConfrence } = this.state;
    let monthNameShort = data
      ? data.toLocaleString('pt-br', { month: 'long' })
      : '';
    let fullYear = data ? data.getFullYear() : '';
    return (
      <React.Fragment>
        <TopoTitleComponente mainTitle={_.get(entity.paciente, 'nome')} />

        <div
          id={this.props.id}
          className="prontuario-box d-flex flex-column align-items-center"
        >
          <div className="w-100 d-flex justify-content-center">
            {/* {this.props.showAvatar && (
              <Avatar
                namePropsMidiaId={'foto.id'}
                user={entity.paciente}
                className="fixed"
              ></Avatar>
            )} */}
            <div className="calendar-date d-flex flex-row flex-lg-column align-items-center justify-content-center">
              <div className="font-date">{data && data.getDate()}</div>
              <p className="nome-mes">{monthNameShort}</p>
              <p className="ano">{fullYear}</p>
            </div>
          </div>
          <div className="d-flex flex-column">
            {atendimentoParaChamar && (
              <div className="box-folhas">
                <div className="cardInfo d-flex flex-lg-row flex-column align-items-center justify-content-between">
                  <img
                    src={IconChamarPaciente}
                    alt="Imagem Link agendamento online"
                  />
                  <div className="d-flex flex-column flex-fill">
                    <p className="title">O Paciente ainda não foi chamado</p>
                    <p className="instruction">
                      O paciente está aguardando ser chamado na sala de espera,
                      chame o paciente para iniciar o atendimento.
                    </p>
                  </div>
                  <ButtonAutorized
                    className="btn-secondary open"
                    label={'Chamar paciente'}
                    role={objectsConstants.AGENDA_ATENDER}
                    onClick={() => {
                      this.props.handleStatusChanged(
                        objectsConstants.EM_CHAMADA,
                        atendimentoParaChamar,
                        atendimentoParaChamar
                      );
                    }}
                  ></ButtonAutorized>
                </div>
              </div>
            )}
            {atendimentoMarcado && atendimentoMarcado.telemedicina && (
              <div className="box-folhas">
                <div className="cardInfo d-flex flex-lg-row flex-column align-items-center justify-content-between">
                  <img
                    src={IconChamarPaciente}
                    alt="Imagem Link agendamento online"
                  />
                  <div className="">
                    <p className="title">Teleconsulta</p>
                    <p className="instruction">
                      O paciente está aguardando ser chamado na sala de espera,
                      chame o paciente para iniciar o atendimento.
                    </p>
                    <button
                      className="btn btn-sm btn-secondary"
                      title="Reenviar link de acesso"
                      onClick={() => {
                        this.sendEmail(atendimentoMarcado);
                      }}
                    >
                      <img
                        src={IconSend}
                        alt="Reenviar link de acesso por email"
                        className={'ma-icon'}
                      />
                      Reenviar link de acesso para o paciente
                    </button>
                    {/* <button
                      className="btn btn-sm btn-primary"
                      title="Copiar link"
                      onClick={() => {
                        this.copiaLink(atendimentoMarcado.nomeSalaPaciente);
                      }}
                    >
                      Copiar url da sala
                    </button> */}
                  </div>
                  <ButtonAutorized
                    className="btn-primary save"
                    label={'Iniciar teleconsulta'}
                    role={objectsConstants.AGENDA_ATENDER}
                    onClick={() => {
                      this.props.setTelemedicina({
                        nomeSala: atendimentoMarcado.nomeSala,
                        showTelemedicina: true,
                      });
                      this.abreSalaTeleAtendimento(atendimentoMarcado);
                      this.props.handleStatusChanged(
                        objectsConstants.EM_ATENDIMENTO,
                        atendimentoMarcado,
                        atendimentoMarcado
                      );
                    }}
                  ></ButtonAutorized>
                </div>
              </div>
            )}
            {atendimentoEmChamada && (
              <div className="box-folhas">
                <div className="cardInfo d-flex flex-lg-row flex-column align-items-center justify-content-between">
                  <img
                    src={IconIniciarAtendimento}
                    alt="Imagem Link agendamento online"
                  />
                  <div className="d-flex flex-column flex-fill">
                    <p className="title">
                      O paciente já chegou ao seu consultório?
                    </p>
                    <p className="instruction">
                      Ao clicar iniciar atendimento, o sistema irá parar de
                      chamar o paciente na sala de espera e assim o atendimento
                      será iniciado.
                    </p>
                  </div>
                  <ButtonAutorized
                    className="btn-secondary open"
                    label={'Iniciar atendimento'}
                    role={objectsConstants.AGENDA_ATENDER}
                    onClick={() => {
                      this.props.handleStatusChanged(
                        objectsConstants.EM_ATENDIMENTO,
                        atendimentoEmChamada,
                        atendimentoEmChamada
                      );
                    }}
                  ></ButtonAutorized>
                </div>
              </div>
            )}
          </div>

          {!atendimentoParaChamar &&
            !atendimentoEmChamada &&
            !(atendimentoMarcado && atendimentoMarcado.telemedicina) && (
              <React.Fragment>
                <div className="d-flex flex-column">
                  {this.canEditAnamnese(entity) && (
                    <button
                      type="button"
                      className="btn btn-info"
                      onClick={this.toggleModalGerarDocumentos}
                    >
                      Gerar documentos
                    </button>
                  )}
                  {prontuarioImportado && (
                    <button
                      type="button"
                      className="btn btn-info"
                      onClick={this.toggleModalConsultarProntuario}
                    >
                      Consultar Prontuario
                    </button>
                  )}
                </div>
                <div className="d-flex flex-column flex-lg-row w-100 box-folhas justify-content-around mt-2 mb-3">
                  <FolhaCard
                    entity={initValues}
                    className={''}
                    icon={iconePaciente}
                    title={
                      this.getIdade(entity.paciente.dataNascimento) +
                      '' +
                      this.getNomeConvenio()
                    }
                    Componente={AnamneseDadosForm}
                    viewMode={this.props.viewMode}
                    callbackOnSave={(values, atendimentoEmAtendimento) => {
                      this.setState({ documentosGerados: [] }, () => {
                        this.props.onSave(values, atendimentoEmAtendimento);
                      });
                    }}
                    showEdit={this.canEditAnamnese(entity)}
                    toggleReceituario={this.toggleReceituario}
                    receituarioON={showReceituario}
                    exibeBotaoReceituario={this.exibeBotaoReceituario(entity)}
                    atendimentoEmAtendimento={atendimentoEmAtendimento}
                    documentosGerados={this.state.documentosGerados}
                    // podeCriarReceituario={this.props.podeCriarReceituario}
                  />
                  <FolhaCardPanel
                    className={''}
                    icon={iconeReceituario}
                    title={'Receituário'}
                    Componente={AnamneseReceiruarioForm}
                    viewMode={
                      showReceituario || !entity.receituario ? false : true
                    }
                    paciente={entity.paciente}
                    entity={entity}
                    callbackOnSave={this.props.onSave}
                    canSave={true}
                    showEdit={this.canEditAnamnese(entity)}
                    estabelecimento={estabelecimento}
                  />
                  {/* {((entity.receituario && entity.receituario.id) ||
                    showReceituario) && (

                  )}*/}
                </div>
              </React.Fragment>
            )}
          {this.canEditAnamnese(entity) && (
            <ModalGerarDocumentos
              ref={(gerarDocumentos) =>
                (this._gerarDocumentosInput = gerarDocumentos)
              }
              name="listGerarDocumentos"
              toogle={this.toggleModalGerarDocumentos}
              isOpen={this.state.openModalGerarDocumentos}
              target={'gerarDocumentos'}
              user={this.props.user}
              success={this.props.success}
              loading={this.props.loading}
              error={this.props.error}
              marcacao={this.state.marcacao}
              entity={this.props.entity}
              callbackOnSave={(entity) => {
                console.log('callbackOnSave ModalGeraDocumento Anamnese');
                let documentosGerados = _.cloneDeep(
                  this.state.documentosGerados
                );
                documentosGerados.push(entity);
                this.setState({ documentosGerados });
              }}
              {...otherProps}
            />
          )}
          {this.canEditAnamnese(entity) && (
            <ModalConsultarProntuario
              ref={(gerarDocumentos) =>
                (this._gerarDocumentosInput = gerarDocumentos)
              }
              loadListAnamnese={this.props.loadListAnamnese}
              name="listGerarDocumentos"
              toogle={this.toggleModalConsultarProntuario}
              isOpen={this.state.openModalConsultarProntuario}
              target={'gerarDocumentos'}
              user={this.props.user}
              load={this.props.loading}
              marcacao={
                this.state.marcacao
                  ? this.state.marcacao
                  : this.props.atendimentoEmAtendimento
              }
              entity={entity}
              callbackOnSave={(entity) => {}}
            />
          )}
          {this.loadVideoConferencia()}
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatch = ({
  anamnese: { setTelemedicina },
  alert: { success, error, clear },
  load: { loading },
}) => ({
  setTelemedicina: (options) => setTelemedicina(options),
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { showTelemedicina, nomeSala } = state.anamnese;
  return {
    user,
    showTelemedicina,
    nomeSala,
  };
}
export default connect(
  mapStateToProps,
  mapDispatch,
  null
)(withRouter(Anamnese));
